import React, { MouseEventHandler } from 'react';

import { DetailWidgetInteractionItem, StyleProps } from '../WidgetElement';
import { sendInteractGATrackEventData } from '../../../../util/gAUtil';

const generateHotspotStyle = (isHover: boolean, clickable: boolean, style: StyleProps) => {
	const {
		transformSettings: {
			borderRadiusBottom,
			borderRadiusLeft,
			borderRadiusRight,
			borderRadiusTop,
			paddingBottom,
			paddingLeft,
			paddingRight,
			paddingTop,
			hoverPaddingBottom,
			hoverPaddingLeft,
			hoverPaddingRight,
			hoverPaddingTop,
		},
		backgroundSettings: { backgroundColor, hoverBackgroundColor },
	} = style;

	return {
		display: 'flex',
		width: '100%',
		height: '100%',
		backgroundColor: isHover ? hoverBackgroundColor : backgroundColor,
		cursor: clickable ? 'pointer' : 'null',
		borderTopRightRadius: `${borderRadiusTop}px`,
		borderBottomRightRadius: `${borderRadiusRight}px`,
		borderBottomLeftRadius: `${borderRadiusBottom}px`,
		borderTopLeftRadius: `${borderRadiusLeft}px`,
		paddingBottom: isHover ? hoverPaddingBottom : paddingBottom,
		paddingLeft: isHover ? hoverPaddingLeft : paddingLeft,
		paddingRight: isHover ? hoverPaddingRight : paddingRight,
		paddingTop: isHover ? hoverPaddingTop : paddingTop,
	};
};

const Hotspot = ({
	id,
	style,
	data,
	clickable,
	isHover,
	scenarioId,
	sceneId,
	widgetRef,
	onClick,
	handleMouseEnter,
	handleMouseLeave,
}: DetailWidgetInteractionItem) => {
	const {
		coordinate: { x, y },
		dimension: { w = 150, h = 100 },
		rotation,
	} = style;

	const centerPoint = {
		x: x + w - w / 2,
		y: y + h - h / 2,
	};

	const { name, type } = data;

	const handleWidgetAction = (event: React.TouchEvent | React.MouseEvent) => {
		event.stopPropagation();
		sendInteractGATrackEventData(type, name, scenarioId, sceneId);
		onClick(event);
	};

	return (
		<g
			id={id}
			onTouchStart={handleWidgetAction}
			onClick={handleWidgetAction}
			onMouseEnter={handleMouseEnter as MouseEventHandler<SVGGElement>}
			onMouseLeave={handleMouseLeave as MouseEventHandler<SVGGElement>}
		>
			<foreignObject
				ref={widgetRef}
				x={x}
				y={y}
				width={w}
				height={h}
				style={{ transformOrigin: `${centerPoint.x}px ${centerPoint.y}px`, transform: `rotate(${rotation ?? 0}deg)` }}
			>
				<div style={generateHotspotStyle(isHover, clickable, style)} />
			</foreignObject>
		</g>
	);
};

export default Hotspot;
